import { render, staticRenderFns } from "./LeaveFeedback.vue?vue&type=template&id=f57bf22a&lang=pug"
import script from "./LeaveFeedback.vue?vue&type=script&lang=js"
export * from "./LeaveFeedback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports